export const updateSidebarData = (staticMenu, backendMenu) => {
  const backendMapByMainId = new Map();

  backendMenu?.forEach(item => {
    if (item.mainId !== undefined) backendMapByMainId.set(item.mainId, item);
  });

  const updatedMenu = staticMenu.map(staticItem => {
    const backendItem = backendMapByMainId.get(staticItem.mainId); // ✅ backend.mainId === static.id

  
    const backendSubMap = new Map();
    if (backendItem?.Subfields?.length) {
      backendItem.Subfields.forEach(sub => {
        if (sub.subId !== undefined) backendSubMap.set(sub.subId, sub);
      });
    }

    const updatedSubfields = (staticItem.Subfields || []).map(staticSub => {
      const backendSub = backendSubMap.get(staticSub.subId); // ✅ backend.sub.subId === static.sub.id
      return {
        ...staticSub,
        status: backendSub?.status !== undefined ? backendSub.status : staticSub.status,
      };
    });

    return {
      ...staticItem,
      status: backendItem?.status !== undefined ? backendItem.status : staticItem.status,
      Subfields: updatedSubfields,
    };
  });

  return updatedMenu;
};
